import { atom } from 'jotai';
import { PatientBasicsDto } from '../api/generated/model';

export const tracingContactSearchTextAtom = atom('');

export enum TracingContactTableFilter {
  ALL = 'ALL',
  PENDING = 'PENDING',
  APPOINTMENT_ARRANGED = 'APPOINTMENT_ARRANGED',
  NO_UU_NEEDED = 'NO_UU_NEEDED',
  TEST_EXECUTED = 'TEST_EXECUTED',
  WAITING_PERIOD = 'WAITING_PERIOD',
}

export const tracingContactTableFilterAtom = atom<TracingContactTableFilter>(TracingContactTableFilter.ALL);

export const tracingContactSelectedPatientFilterAtom = atom<PatientBasicsDto | null>(null);
